import {TFunction} from 'i18next';
import {constructFilter} from './constructFilter';
import {AreaSensorInfo} from '@lib/store';

export const SECTION_ID_OCCUPANCY_LEVELS = 'SECTION_ID_OCCUPANCY_LEVELS';

export const constructOccupancyFilter = <TEntity extends {sensorInformation: AreaSensorInfo | null}>(t: TFunction) => {
  const occupancyStatusList = [
    {id: 'quiet', label: t('Quiet')},
    {id: 'lively', label: t('Lively')},
    {id: 'busy', label: t('Busy')},
    {id: 'full', label: t('Full')},
    {id: 'unknown', label: t('NoSensorData')},
  ];

  return constructFilter({
    sectionId: SECTION_ID_OCCUPANCY_LEVELS,
    sectionTitle: t('Occupancy'),
    type: 'or',
    data: occupancyStatusList,
    defaultFilterOptions: [],
    predicate: (filter, entity: TEntity) =>
      entity.sensorInformation?.status === filter.id || (!entity.sensorInformation?.status && filter.id === 'unknown'),
  });
};
